import FlyDirect from "./FlyDirect.js";
import {getDownwindWaypoints} from "../../assets/virtual-flyout/nav-calc.js";
import {getVapp} from "../../assets/virtual-flyout/perf-calc.js";
import {setTas} from "../planeSlice.js";
import {getActiveRunway} from "../../assets/virtual-flyout/airport-service.js";

const CIRCUIT_DIRECTION  = "left";

export default class FlyDownwind extends FlyDirect {
    constructor(planeId, airport) {
        super(planeId);
        this.airport = airport;
    }

    logAction() {
        this.log(`Downwind runway ${this.runway}`);
    }

    execute() {
        const planeState = this.getState();
        this.runway = getActiveRunway(this.airport.code, planeState.wind.heading).runway;
        this.waypoint = getDownwindWaypoints(this.airport, this.runway, CIRCUIT_DIRECTION)[1];
        super.execute();
        this.dispatch(setTas({tas: getVapp()}));
    }
}
